import axios from '@dap/shared-utils/http.js';

export default {
    getDict (params) {
        return axios.get('/dapper/api/review/review_dict', { params });
    },

    getTableList (params) {
        return axios.get('/dapper/api/review/reviews', { params });
    },

    getDetail (params) {
        return axios.get('/dapper/api/review/detail', { params });
    },

    auditPass (params) {
        return axios.post('/dapper/api/review/pass', params);
    },

    failPass (params) {
        return axios.post('/dapper/api/review/fail_pass', params);
    },

    // 详情页面审核历史表格审核意见修改
    editAuditOpinion (params) {
        return axios.post('/dapper/api/review/history/edit', params);
    },

    getSensitiveWords (params = {}) {
        return axios.get('/dapper/api/review/prohibited_sensitive_words', {
            params,
        });
    },

    // 合规审核列表页审核意见修改
    editListAuditOpinion (params) {
        return axios.post('/dapper/api/review/edit', params);
    },

    checkIsUsed (params) {
        return axios.get('/dapper/api/review/is_used', { params });
    },
};
